import auth from 'src/router/middleware/authentification/auth.js'

const MoreWrapper = () => import('src/views/More/MoreWrapper.vue')
const FeedbackModal = () => import('src/components/miscellaneous/ui/texts/feedback/FeedbackModal.vue')
const Administration = () => import('src/views/Management/Administration.vue')
const ChannelList = () => import('src/views/Channels/Channel/ChannelList.vue')
const Wrapper = () => import('src/views/Miscellaneous/Help/HelpWrapper.vue')
const Start = () => import('src/views/Miscellaneous/Help/Help.vue')
const Articles = () => import('src/views/Miscellaneous/Help/HelpArticles.vue')
const ArticleDetails = () => import('src/views/Miscellaneous/Help/HelpArticleDetails.vue')
const SduiPlusWrapper = () => import('src/views/More/SduiPlus/SduiPlusLinkList.vue')
const SduiPlusSingle = () => import('src/views/More/SduiPlus/SduiPlusLinkDetails.vue')

export default [
  {
    path: '/more',
    component: MoreWrapper,
    name: 'more',
    meta: {
      layout: 'sdui',
      middleware: [auth],
      group: 'more',
      headerText: 'global.headers.more',
      enableSwReload: true,
    }
  },
  {
    path: '/help',
    name: 'help',
    component: Wrapper,
    children: [
      {
        path: 'start',
        name: 'help-start',
        component: Start,
        meta: {
          transitionPoint: 3,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'articles/:category?',
        name: 'help-articles',
        component: Articles,
        meta: {
          transitionPoint: 4,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'article-details/:category?/:article?',
        name: 'help-article-details',
        component: ArticleDetails,
        meta: {
          transitionPoint: 5,
          headerText: 'global.headers.help'
        }
      },
      {
        path: 'send/:code?',
        component: FeedbackModal,
        name: 'help-send-feedback',
        meta: {
          transitionPoint: 6,
          headerText: 'global.headers.contact_support'
        }
      },
      {
        path: 'report',
        component: FeedbackModal,
        name: 'help-send-report',
        meta: {
          transitionPoint: 6,
          headerText: 'global.headers.contact_support'
        }
      }
    ]
  },
  {
    path: '/more/administration',
    component: Administration,
    name: 'administration',
    meta: {
      middleware: [auth],
      headerText: 'global.headers.administration'
    }
  },
  {
    path: '/more/channels',
    component: ChannelList,
    name: 'lite-channels',
    meta: {
      layout: 'sdui',
      middleware: [auth],
      headerText: 'global.headers.groups',
      iconChannels: 'icon-group'
    }
  },
  {
    path: '/more/sdui-plus',
    component: SduiPlusWrapper,
    name: 'sdui-plus',
    meta: {
      middleware: [auth],
      headerText: 'global.headers.sdui_plus'
    }
  },
  {
    path: '/more/sdui-plus/:uuid',
    component: SduiPlusSingle,
    name: 'sdui-plus-partner',
    meta: {
      middleware: [auth],
      headerText: 'global.headers.sdui_plus'
    }
  }
]
